import { CommonButton } from 'components/Buttons';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { modalActionType, actionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const SendToWorkflow = () => {
  const dispatch = useDispatch();
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const t = utils.intl.useTranslator();
  const saveDocument = utils.hooks.useSaveDocument();
  const disabled = !utils.user.isActionEnabled(records, actionType.OPEN_WORKFLOW);
  const { checkDocuments } = useCheckBeforeAction(actionType.OPEN_WORKFLOW);

  const action = useCallback(async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    const response = await saveDocument();
    if (response === null) {
      return;
    }
    dispatch(actions.modal.openModal(modalActionType.documents.SEND_TO_WORKFLOW));
  }, [dispatch, saveDocument, checkDocuments]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'F11' && !disabled) {
        event.preventDefault();
        action();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [action, disabled]);

  return (
    <CommonButton
      id="send-to-workflow-btn"
      action={action}
      disabled={disabled}
      scope="tertiary"
      value={t('sendToWorkflow')}
      customIcon="workflow"
    />
  );
};

export default SendToWorkflow;
